/**
 * FreeSpinsIntroOutroView
 *
 * Handles the view functionality of the free spins dialog(s)
 */
(function () {
  class FreeSpinsIntroOutro extends PIXI.Container {
    constructor() {
      super();

      this._callback = undefined;

      this.visible = false;

      this._spinsWon = undefined;
      this._cashWon = undefined;

      this._freeSpinsText = undefined;
      this._fromFreeSpinsText = undefined;

      this._pressStartBox = undefined;
    }

    initialise() {
      const self = this;

      messageBus.subscribe("spinner:GameConfigEvent", function () {
        self.onLayoutComplete();
      });
    }

    onLayoutComplete() {
      this._spinsWon = resourceManager.get(
        "freeSpinsIntroOutroContainer:FreeSpinsIntroOutro:numFreeSpinsText"
      );
      this._spinsWon.visible = false;

      this._cashWon = resourceManager.get(
        "freeSpinsIntroOutroContainer:FreeSpinsIntroOutro:cashWonText"
      );
      this._cashWon.visible = false;

      this._freeSpinsText = resourceManager.get(
        "freeSpinsIntroOutroContainer:FreeSpinsIntroOutro:freespinsText"
      );
      this._freeSpinsText.visible = false;

      this._fromFreeSpinsText = resourceManager.get(
        "freeSpinsIntroOutroContainer:FreeSpinsIntroOutro:fromFreespinsText"
      );
      this._fromFreeSpinsText.visible = false;

      this._pressStartBox = resourceManager.get(
        "freeSpinsIntroOutroContainer:FreeSpinsIntroOutro:pressStartColourBox"
      );

      this._pressStartBox.alpha = 0;
      this._pressStartBox.visible = false;
      this._pressStartBox.interactive = false;
    }

    setup() {
      let reels = resourceManager.get("slotContainer:reelContainer");
      reels.alpha = 0.0;

      resourceManager.get(
        "freeSpinsIntroOutroContainer:FreeSpinsIntroOutro"
      ).visible = true;

      this._pressStartBox.visible = true;
      this._pressStartBox.alpha = 0;
    }

    showIntro(numFS, callback) {
      this.setup();

      this._callback = callback;
      this._spinsWon.visible = true;
      this._freeSpinsText.visible = true;
      this._cashWon.visible = false;
      this._fromFreeSpinsText.visible = false;

      this._spinsWon.text = numFS;

      this.bounceIn(this._spinsWon, 0, undefined, this._spinsWon.scale.x);
      this.bounceIn(
        this._freeSpinsText,
        0,
        undefined,
        this._freeSpinsText.scale.x
      );

      soundManager.play("transition");

      resourceManager.get("trail:TrailContainer").switchTrail("trailX3");
    }

    bounceIn(object, delay, duration, scale) {
      gsap.fromTo(
        object.scale,
        {
          x: 0,
          y: 0,
        },
        {
          delay: delay,
          duration: duration ?? 1,
          ease: "Bounce.easeOut",
          x: scale ?? 1,
          y: scale ?? 1,
          onStart: () => {
            object.visible = true;
            object.alpha = 1;
          },
          onComplete: () => {
            this.setActive();
          },
        }
      );
    }

    setActive() {
      this._pressStartBox.interactive = true;
      this._pressStartBox.mousedown = this._pressStartBox.touchstart =
        this.closeDialog.bind(this);
    }

    showOutro(cashWon, callback) {
      this.setup();

      this._callback = callback;

      this._spinsWon.visible = false;

      this._cashWon.visible = true;

      this._freeSpinsText.visible = false;

      this._cashWon.setText(gdk.formatCurrency(cashWon));

      this.bounceIn(
        this._fromFreeSpinsText,
        undefined,
        undefined,
        this._fromFreeSpinsText.scale.x
      );
      this.bounceIn(this._cashWon, undefined, undefined, this._cashWon.scale.x);

      var trailType = gameData.encoreEnabled ? "trailX3" : "trailX4";
      resourceManager.get("trail:TrailContainer").switchTrail(trailType);
    }

    closeDialog() {
      let reels = resourceManager.get("slotContainer:reelContainer");
      reels.alpha = 1.0;
      // turn off click processing
      this._pressStartBox.visible = false;
      this._pressStartBox.alpha = 0;
      this._pressStartBox.interactive = false;
      this._pressStartBox.mousedown = this._pressStartBox.touchstart =
        undefined;

      resourceManager.get(
        "freeSpinsIntroOutroContainer:FreeSpinsIntroOutro"
      ).visible = false;

      soundManager.play("buttonPressV1");

      this._callback();
    }
  }

  let freeSpinsIntroOutroCreator = function (json) {
    return new FreeSpinsIntroOutro();
  };

  let freeSpinsIntroOutroInitialiser = function (json, disclaimer) {
    disclaimer.initialise();
  };

  let freeSpinsIntroOutroFilesRequired = function () {
    return [];
  };

  resourceManager.registerObjectType(
    "FreeSpinsIntroOutro",
    freeSpinsIntroOutroCreator,
    freeSpinsIntroOutroInitialiser,
    freeSpinsIntroOutroFilesRequired
  );
})();
